// types/news.ts

export type NewsItem = {
  id: string;
  title: string;
  description?: string;
  fullDescription?: string;
  image?: string;
  previewImage?: string;
  carouselImages?: string[];
  createdAt?: string;
};

export type NewsApiResponse = {
  _id: string;
  title: string;
  shortDescription?: string;
  fullDescription?: string;
  previewImage?: string;
  carouselImages?: string[];
  createdAt?: string;
};

export const mapNews = (n: NewsApiResponse): NewsItem => ({
  id: n._id,
  title: n.title,
  description: n.shortDescription,
  fullDescription: n.fullDescription,
  image: n.previewImage,
  previewImage: n.previewImage,
  carouselImages: n.carouselImages ?? [],
  createdAt: n.createdAt,
});

export const mapNewsArray = (arr: NewsApiResponse[]): NewsItem[] =>
  arr.map(mapNews);